<template>
  <component
    :is="currentView"
    transition-mode="out-in"
    @transitionend.stop
    :registrationData="registrationData"
    @continue="next"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InitLoader from "@/components/partials/InitLoader";
import RegisterForm from "./Form";
import Success from "./Success";

export default {
  name: "auth-register",
  components: { InitLoader, RegisterForm, Success },
  data: function() {
    return {
      currentStep: 0,
      steps: ["InitLoader", "RegisterForm", "Success"]
    };
  },
  computed: {
    ...mapGetters("user", {
      registrationData: "getTemp"
    }),
    currentView() {
      return this.steps[this.currentStep];
    }
  },
  watch: {
    registrationData: "next"
  },
  methods: {
    ...mapActions("user", {
      getUserRegistrationData: "getUserRegistrationData"
    }),
    next() {
      this.currentStep += 1;
    }
  },
  mounted: function() {
    setTimeout(() => {
      this.getUserRegistrationData();
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
